import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { Card, TextLink } from '@wit-support/ui';
import { CornerUpLeft } from 'lucide-react';
/**
 * Banner shown at the top of a conversation that was minted as a child of a
 * locked (resolved >30d or closed) conversation by the threading resolver.
 * Lets operators jump back to the original thread for context.
 */
export function ContinuedFromBanner({ parentId, parentSubject, }) {
    const label = parentSubject?.trim() || 'previous conversation';
    return (_jsxs(Card, { role: "note", className: "flex items-center gap-3 px-4 py-2.5 text-sm", children: [_jsx(CornerUpLeft, { className: "h-4 w-4 shrink-0 text-[var(--color-text-muted)]", "aria-hidden": "true" }), _jsxs("span", { className: "min-w-0 flex-1 text-[var(--color-text-secondary)]", children: ["Continued from previous conversation:", ' ', _jsx(TextLink, { asChild: true, children: _jsx(Link, { to: "/conversations/$conversationId", params: { conversationId: parentId }, children: label }) })] })] }));
}
//# sourceMappingURL=continued-from-banner.js.map